import { CodedProperty, getSortedCollection, SprintQueryResult, useSprintQuery } from "sprint-common-web";

import { useAdminApi } from "../../api/admin-api/useAdminApi";
import { mapToAirline } from "../../types/Airline";
import { DataHooksQueryKey } from "./DataHooksQueryKey";

export const useAirlines = (): SprintQueryResult<CodedProperty[]> => {
    const { getAirlinesLookup } = useAdminApi();

    return useSprintQuery<CodedProperty[]>({
        queryKey: [DataHooksQueryKey.OrderAirlines],
        queryFn: async (): Promise<CodedProperty[]> => {
            const response = await getAirlinesLookup();
            const items = response.items.map((item) => mapToAirline(item));
            return getSortedCollection(items, "name");
        }
    });
};
